export default "__VITE_ASSET__wYd_m1v8__"